// extracted by mini-css-extract-plugin
module.exports = {"warrantyReturns__description-p":"WarrantyReturnsParagraph_warrantyReturns__description-p__lSVBi"};